var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { useEffect, Fragment, useMemo, useState, } from 'react';
import { Redirect } from 'react-router-dom';
import { isLazyComponent } from '../util/Route';
import { useLocation } from 'react-router-dom';
import { matchPath, __RouterContext as RouterContext, } from 'react-router';
import { useRouter } from '../hooks/useRouter';
import { BigSpinner } from './BigSpinner';
import qs from 'qs';
import { useCheckForUpdates } from '../hooks/useCheckForUpdates';
export function RouteSwitch(_a) {
    var location = _a.location, routes = _a.routes, DefaultRoute = _a.defaultRoute, defaultRouteParams = _a.defaultRouteParams, children = _a.children;
    var trueLocation = useLocation();
    var _b = useState(children), view = _b[0], setView = _b[1];
    var _c = useMatchRoute(location || trueLocation, routes), route = _c[0], context = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    useCheckForUpdates();
    useEffect(function () {
        if (!route)
            return;
        if (isLazyComponent(route.possiblyLazyView) && !route._view) {
            setLoading(true);
            route.load().then(function (View) {
                setLoading(false);
                setView(jsx(RouterContext.Provider, { value: context },
                    jsx(View, __assign({}, context))));
            });
        }
        else {
            setView(jsx(RouterContext.Provider, { value: context },
                jsx(route.view, __assign({}, context))));
        }
    }, [context, route]);
    return (jsx(Fragment, null,
        route ? (view) : DefaultRoute === true ? (jsx(Redirect, { to: routes[0].formatPath((defaultRouteParams || {})) })) : (DefaultRoute && jsx(DefaultRoute, __assign({}, defaultRouteParams))),
        loading && (jsx("div", { sx: {
                position: 'absolute',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                bg: '#888',
                opacity: 0.2,
            } },
            jsx(BigSpinner, null)))));
}
function useMatchRoute(location, routes) {
    var context = useRouter();
    return useMemo(function () {
        for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
            var route = routes_1[_i];
            var match = matchPath(location.pathname, {
                path: route.path,
                exact: route.options.exact,
            });
            var query = location.search
                ? qs.parse(location.search.substring(1))
                : {};
            if (match) {
                return [
                    route,
                    __assign(__assign({}, context), { match: __assign(__assign({}, match), { params: __assign(__assign({}, match.params), query) }), location: location }),
                ];
            }
        }
        return [null, context];
    }, [context, location, routes]);
}
//# sourceMappingURL=RouteSwitch.js.map